"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Linkedin;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Linkedin(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("title", null, "LinkedIn"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Social_media",
    "data-name": "Social media"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "linkedin",
    d: "M27.907,89.991H11.321v-53.4H27.907Zm62.075,0H73.432V64c0-6.195-.125-14.14-8.623-14.14-8.623,0-9.944,6.731-9.944,13.693V89.991H38.3v-53.4H54.2v7.284h.232c2.214-4.195,7.624-8.623,15.693-8.623C86.911,35.253,90,46.3,90,60.658V89.991ZM29.21,19.614a9.605,9.605,0,1,0-9.6,9.694A9.608,9.608,0,0,0,29.21,19.614Z"
  })));
}